import { defineMessages } from 'react-intl';

export default defineMessages({
    welcomeBack: {
        id: '_.endedview.welcome_back',
        defaultMessage: 'Hi {firstName}, welcome back'
    },
    // New Loan Ended Messages
    newWelcomeBack: {
        id: '_.endedview.new_loan_ended_section.welcome_back',
        defaultMessage: 'Welcome back, {name}'
    },
    subtitle: {
        id: '_.endedview.new_loan_ended_section.subtitle',
        defaultMessage: 'You finished repaying your last loan on {date}'
    },
    loanSummaryActionTitle: {
        id: '_.endedview.new_loan_ended_section.loan_summary_action_title',
        defaultMessage: 'Want to see what we can offer you this time?'
    },
    bulletpointOne: {
        id: '_.endedview.new_loan_ended_section.bulletpoint_one',
        defaultMessage: 'Applying is free and takes less than 5 minutes'
    },
    bulletpointTwo: {
        id: '_.endedview.new_loan_ended_section.bulletpoint_two',
        defaultMessage: "It won't affect your credit score"
    },
    bulletpointThree: {
        id: '_.endedview.new_loan_ended_section.bulletpoint_three',
        defaultMessage:
            'If approved, you are under no obligation to take the funds'
    },
    amountInputTitle: {
        id: '_.endedview.new_loan_ended_section.amount_input_title',
        defaultMessage: 'How much would you like to borrow?'
    },
    turnoverInputTitle: {
        id: '_.endedview.new_loan_ended_section.turnover_input_title',
        defaultMessage:
            'How much did your business turn over in the last 12 months?'
    }
});
